// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wifi-off';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 16.969 16.97 1.03M6.875 14.844a2.125 2.125 0 1 0 4.25 0 2.125 2.125 0 0 0-4.25 0zm5.879-3.756a5.296 5.296 0 0 0-1.596-1.096M8.47 6.36a8.465 8.465 0 0 0-5.48 2.473m12.02 0a8.51 8.51 0 0 0-1.792-1.37m-2.127-4.118a11.676 11.676 0 0 0-10.06 2.95m15.938 0a11.66 11.66 0 0 0-1.727-1.332'
  />
);

export const viewBox = '0 0 18 18';
